"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useIsMounted", {
    get: ()=>useIsMounted,
    enumerable: true
});
const _react = require("react");
function useIsMounted(allowTests = false) {
    const [mounted, setMounted] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if (!allowTests && process.env.NODE_ENV === 'test') {
            return;
        }
        setMounted(true);
    }, [
        allowTests
    ]);
    return mounted;
}
